import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";

/*
https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest
s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest
*/

function LoadDataset(prop) {
    const [dataset, setDataset] = useState('https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest');
    // const [dataset, setDataset] = useState('s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest');
    const [chosenDataset, setChosenDataset] = useState('');

    const [state, setState] = useState('enterurl');
    var dataSetNames = [];
    function datasetChange(ev)
    {
        setDataset( ev.target.value );
    }
    function chooseDatasetChange(ev)
    {
        setChosenDataset( ev.target.value );
    }
    function submit(e)
    {
        e.preventDefault();
        setState('loading');
        window.post( 'load_dataset', {url:dataset,dsName:chosenDataset}, res => {
            console.log( 'RESULT', res.data.chooseDataset );
            if( res.data.chooseDataset ) // need to select dataSetName
            {
                window.GlobalVars.chooseDataset = res.data.chooseDataset;
                return setState( 'selectdataset' );
            }
            window.clearSession();
            return setState('done');
        });

    }
    function clearData()
    {
        setState('clearData');
        window.clearSession();
        var loc = document.location;
        var url = loc.protocol + '//' + loc.hostname + ':8088/clear_data';
        axios.post( url, {} ).then( res => {
            setState('done');
        })

    }

    useEffect( function(){
    },[]);

    if( state == 'loading')
    {
        return (
            <Container fluid="md">
            <Row>
            <Col sm={10}>
            <Alert variant="secondary">
            <Spinner animation="border" variant="secondary"  size="sm" role="status">
            <span className="sr-only">Loading...</span>
            </Spinner>
              <span class="ml-2">Loading Dataset. Please wait.</span>
            </Alert>
            </Col>
            </Row>
            </Container>
        )
    }
    else if( state == 'clearData')
    {
        return (
            <Container fluid="md">
            <Row>
            <Col sm={10}>
            <Alert variant="light">
              Clearing Data. Please wait.
            </Alert>
            </Col>
            </Row>
            </Container>
        )
    }
    else if( state == 'done' )
    {
        document.location = '#Datasets';
        setTimeout( window.GlobalVars.update, 1 );
        return (
            <Alert variant="light">
              Going home.
            </Alert>
        )
    }
    else if( state == 'selectdataset' )
    {
        return (
            <Container fluid="md">
            <Row>
            <Col sm={10}>
            <Alert variant="danger">
              This manifest ({dataset}) has more than one Dataset. Please select one.
            </Alert>
            </Col>
            </Row>
            <Row>
            <Col sm={10}>
                    <Form action={'/'+prop.page} method="GET"  onSubmit={submit}>
                        <Form.Group controlId="exampleForm.ControlSelect1" class="mt-4">
                          <Form.Label>Select Dataset Name</Form.Label>
                          <Form.Control as="select" value={chosenDataset}  onChange={chooseDatasetChange}>
                            <option value="">(Select Dataset)</option>
                            {
                                window.GlobalVars.chooseDataset.map( dsn => {
                                    return (
                                        <option>{dsn}</option>
                                    )
                                })
                            }
                          </Form.Control>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-2">Continue</Button>
                    </Form>
            </Col>
            </Row>
            </Container>
        )
    }
    return (
        <Container fluid="md">
        <Row>
        <Col sm={10}>
                <Form action={'/'+prop.page} method="GET"  onSubmit={submit}>
                    <Form.Label>Enter Dataset Manifest URL</Form.Label>
                    <FormControl type="text" id="dataseturl" value={dataset} onChange={datasetChange} placeholder="Enter Manifest Url"/>
                    <Button variant="primary" type="submit" className="mt-2">Load Dataset</Button>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <Button variant="danger" onClick={clearData} className="mt-2">Clear All Data</Button>
                </Form>
        </Col>
        </Row>
        </Container>

    )
}

export default LoadDataset
